package uz.ferro.erp.feature.product.utils

object PropertyKeys {
    const val PLAN_VALIDITY = "PLAN_VALIDITY"
    const val PLAN_DATA_LIMIT = "PLAN_DATA_LIMIT"
    const val PLAN_DATA_UNIT = "PLAN_DATA_UNIT"
    const val NETWORKS_SHORT = "NETWORKS_SHORT"
    const val HAS_DATA = "HAS_DATA"
    const val HAS_CALLS = "HAS_CALLS"
    const val HAS_SMS = "HAS_SMS"
    const val HOTSPOT = "HOTSPOT"
    const val SPEED = "SPEED"
    const val ICCID = "ICCID"
    const val SMDP_ADDRESS = "SMDP_ADDRESS"
    const val LOCAL_PROFILE_ASSISTANT = "LOCAL_PROFILE_ASSISTANT"
    const val ACCESS_POINT_NAME = "ACCESS_POINT_NAME"
    const val ACTIVATION_CODE = "ACTIVATION_CODE"
    const val QR_CODE = "QR_CODE"
}